import { render, staticRenderFns } from "./FrequecyViewWeeklyChart.vue?vue&type=template&id=9b4c5bf0&scoped=true&"
import script from "./FrequecyViewWeeklyChart.vue?vue&type=script&lang=js&"
export * from "./FrequecyViewWeeklyChart.vue?vue&type=script&lang=js&"
import style0 from "./FrequecyViewWeeklyChart.vue?vue&type=style&index=0&id=9b4c5bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4c5bf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardText,VCardTitle,VIcon})
